/**
 * Color palette and shape constants used by the renderer.
 * All colors are 24-bit RGB numbers for Pixi.Graphics fills.
 */
export const palette = {
  bg: 0x050810,
  playerFill: 0x6ff3ff,
  playerOutline: 0xa6fbff,
  bulletSpread: 0x88ccff,
  bulletLaser: 0xffff7a,
  bulletHoming: 0xff66cc,
  enemyGrunt: 0xff5555,
  enemyWeaver: 0xffaa33,
  enemySniper: 0xaa66ff,
  enemySwarm: 0xffee66,
  enemySnake: 0x44ffaa,
  enemyOrbit: 0xff8844,
  enemyBullet: 0xffaaaa,
  pickup: 0xffffff,
  pickupSpread: 0x66ccff,
  pickupLaser: 0xffdd44,
  pickupHoming: 0xff66cc,
  pickupShield: 0x44ffbb,
  shield: 0x44ffbb,
  boss: 0xff4444,
  bossBullet: 0xff88aa,
  particle: 0xffffff,
  hud: 0xcfd8ff,
} as const;

/** Logical world width in simulation units. */
export const WORLD_W = 360;
/** Logical world height in simulation units. */
export const WORLD_H = 640;
